export default __webpack_public_path__ + "static/celik-kontruksiyon-yazilimi-b4b22cc0eb21c32457523bca69539c40.png";